import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { stateNames } from '@/constants/common';
export default {
  __name: 'mg-org-type-select',
  setup(__props) {
    const options = (stateNames.OrgTypeNames || []).reduce((prev, cur, idx) => {
      prev.push({
        value: idx,
        label: cur
      });
      return prev;
    }, []);
    return (_ctx, _cache) => {
      const _component_vxe_select = _resolveComponent("vxe-select");
      return _openBlock(), _createBlock(_component_vxe_select, _mergeProps({
        options: _unref(options)
      }, _ctx.$attrs), null, 16, ["options"]);
    };
  }
};